import { Injectable } from '@angular/core';
import { AccessToken } from '../models/access-token';
import { SolaryumHubV1Service } from "./solaryum-hub-v1.service";

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  constructor(
    private solaryumHubV1Service: SolaryumHubV1Service
  ) { }

  public startConnection = (accessToken?: AccessToken) => {
    this.solaryumHubV1Service.startConnection(accessToken);
  };

  public closeConnection() {
    this.solaryumHubV1Service.closeConnection();
  }
}

